import { useAppDispatch } from '../../../store';
import { Button } from '../../ui/components/Button';
import { Modal } from '../../ui/components/Modal';
import { uiActions } from '../../ui/slice';
import { AccountManagement } from './AccountManagement';

export const AccountModal = () => {
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(uiActions.setCurrentModal(null));

  return (
    <Modal
      height={75}
      hide={closeModal}
      modalKey='account'
      width={65}
    >
      <h1 className='text-2xl'>Manage your JustWords account</h1>
      <AccountManagement />
      <div className='w-full flex justify-end mt-4'>
        <Button
          grow={false}
          onClick={closeModal}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};
